import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-photo-source-popover',
  template: `
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ title }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item button *ngFor="let option of options" (click)="selectOption(option.value)">
          <ion-icon [name]="option.icon" slot="start"></ion-icon>
          <ion-label>{{ option.text }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  `,
  styles: [`
    ion-list {
      padding: 0;
    }
    ion-item {
      --padding-start: 16px;
      --padding-end: 16px;
      --padding-top: 12px;
      --padding-bottom: 12px;
    }
  `]
})
export class PhotoSourcePopoverComponent {
  @Input() title: string = 'Select Option';
  @Input() options: { text: string; value: string; icon: string }[] = [];

  constructor(private popoverController: PopoverController) {}

  selectOption(value: string) {
    this.popoverController.dismiss(value);
  }
}